<app-modal class="issue-create-modal">
    <ng-container modal-header>
        <h5 class="modal-title">{{ 'admin.issues.modal.title.view' | translate }}</h5>
    </ng-container>
    <div class="content" modal-body>
        <div *ngIf="isLoading" class="loading-container">
            <app-loading-spinner class="loading-animation"></app-loading-spinner>
        </div>
        <form [formGroup]="issueForm" *ngIf="!isLoading">
            <app-input-switch formControlName="isReplacementOrdered"
                              [formControl]="issueForm.controls['isReplacementOrdered']"
                              [disabled]="true"
                              topLabel="{{'admin.issues.modal.isReplacementOrdered.label' | translate }}">
            </app-input-switch>
            <app-display-label
                [inlineLabel]="false"
                label="{{'admin.issues.modal.status.label' | translate}}"
                [labelClass]="'compact'"
                [value]="issue.status">
            </app-display-label>
            <app-display-label
                label="{{'admin.issues.modal.createdAt.label' | translate}}"
                [labelClass]="'compact'"
                [value]="issue.createdAt"
                [inlineLabel]="false">
            </app-display-label>
            <app-display-label
                label="{{'admin.issues.modal.createdBy.label' | translate}}"
                [labelClass]="'compact'"
                [value]="issue?.user?.fullName"
                [inlineLabel]="false">
            </app-display-label>
            <app-display-label
                label="{{'admin.issues.modal.line.label' | translate}}"
                [labelClass]="'compact'"
                [value]="issue?.line?.name"
                [valueStyle]=""
                [inlineLabel]="false">
            </app-display-label>
            <app-display-label
                [inlineLabel]="false"
                label="{{'admin.issues.modal.reason.label' | translate}}"
                [labelClass]="'compact'"
                [value]="issue?.reason?.name">
            </app-display-label>
            <app-textbox
                label="{{'admin.issues.modal.description.label' | translate}}"
                [labelClass]="'compact'"
                [value]="issue?.description">
            </app-textbox>
            <div *ngIf="issue.tools && issue.tools.length > 0" class="col s12">
                <app-tool-scan-tree
                    [isMaterial]="false"
                    labelText="{{'admin.issues.modal.noActionToolsTitle'| translate}}"
                    [items]="issue.tools">
                </app-tool-scan-tree>
            </div>
            <div *ngIf="issue.approvedTools && issue.approvedTools.length > 0" class="col s12">
                <app-tool-scan-tree
                    [isMaterial]="false"
                    labelText="{{'admin.issues.modal.approvedToolsTitle'| translate}}"
                    [items]="issue.approvedTools">
                </app-tool-scan-tree>
            </div>
            <div *ngIf="issue.rejectedTools && issue.rejectedTools.length > 0" class="col s12">
                <app-tool-scan-tree
                    [isMaterial]="false"
                    labelText="{{'admin.issues.modal.rejectedToolsTitle'| translate}}"
                    [items]="issue.rejectedTools">
                </app-tool-scan-tree>
            </div>
            <div *ngIf="issue.removedBySystemTools && issue.removedBySystemTools.length > 0" class="col s12">
                <app-tool-scan-tree
                    [isMaterial]="false"
                    labelText="{{'admin.issues.modal.removedBySystemToolsTitle'| translate}}"
                    [items]="issue.removedBySystemTools">
                </app-tool-scan-tree>
            </div>
        </form>
    </div>
    <div class="footer" modal-footer>
        <app-button
            type="simple"
            (clicked)="modal.close()">{{ 'generic.buttons.close' | translate }}
        </app-button>
    </div>
</app-modal>
